import React from "react";
import Template from "../components/auth/Template";

function Login() {
  return <Template text="Login to play" formType="login" />;
}

export default Login;
